module.exports = __webpack_public_path__ + "/_resource/background.77139.jpg";